import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { mensagemDoErro } from '../api';
import { useApp } from '../estado';
import { Aviso, Campo } from '../componentes/ui';

export function Login() {
  const { entrar, marca } = useApp();
  const navegar = useNavigate();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const nomeProvedor = marca?.branding.nomeExibicao ?? 'Disparos';

  const enviar = async (evento: FormEvent<HTMLFormElement>) => {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
      navegar('/', { replace: true });
    } catch (falha) {
      setErro(mensagemDoErro(falha));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <main className="login">
      <section className="login__arte" aria-label="Apresentação">
        <div className="login__marca">
          <img
            className="login__logo"
            src={marca?.branding.logoUrl ?? '/logo.svg'}
            alt={nomeProvedor}
            width={112}
            height={112}
          />
        </div>

        <div className="login__discurso">
          <span className="login__selo">
            <span aria-hidden="true">✓</span> Cobrança e relacionamento no WhatsApp
          </span>
          <h1>A régua que você controla, sem tocar no ERP.</h1>
          <p>
            Lembrete, vencimento, inadimplência e aniversário saem pelo WhatsApp com o nome da sua
            empresa — com janela de envio, descadastro e histórico de tudo que foi enviado.
          </p>
        </div>

        <p className="texto-pequeno" style={{ color: 'rgba(255, 255, 255, 0.92)' }}>
          {nomeProvedor} · ambiente do Provedor
        </p>
      </section>

      <section className="login__formulario">
        <div className="login__caixa">
          <div className="pilha pilha--apertada">
            <h1 style={{ fontSize: '1.6rem' }}>Entrar no painel</h1>
            <p className="texto-pequeno">
              Use o acesso do Provedor <strong>{nomeProvedor}</strong>.
            </p>
          </div>

          {erro ? (
            <Aviso tipo="erro" titulo="Não foi possível entrar">
              {erro}
            </Aviso>
          ) : null}

          <form className="pilha" onSubmit={enviar} noValidate>
            <Campo rotulo="E-mail">
              <input
                className="entrada"
                type="email"
                name="email"
                autoComplete="username"
                inputMode="email"
                required
                value={email}
                onChange={(evento) => setEmail(evento.target.value)}
                placeholder="voce@provedor.com.br"
              />
            </Campo>

            <Campo
              rotulo="Senha"
              acao={
                <button
                  type="button"
                  className="botao botao--fantasma botao--pequeno"
                  onClick={() => setMostrarSenha((atual) => !atual)}
                  aria-pressed={mostrarSenha}
                >
                  {mostrarSenha ? 'Ocultar' : 'Mostrar'}
                </button>
              }
            >
              <input
                className="entrada"
                type={mostrarSenha ? 'text' : 'password'}
                name="senha"
                autoComplete="current-password"
                required
                value={senha}
                onChange={(evento) => setSenha(evento.target.value)}
                placeholder="Sua senha"
                style={{ paddingRight: '5.6rem' }}
              />
            </Campo>

            <button type="submit" className="botao botao--primario botao--bloco" disabled={enviando}>
              {enviando ? 'Entrando…' : 'Entrar'}
            </button>
          </form>

          {import.meta.env.DEV ? (
            <p className="login__dica">
              Ambiente de demonstração: <code>admin@interativa.net</code> · senha{' '}
              <code>xmax2026</code>. Nenhuma mensagem sai para a rede com o canal em modo demo.
            </p>
          ) : null}

          <p className="login__rodape">
            O acesso é por Provedor. Se o seu endereço não carregar a marca da sua empresa, fale com
            o suporte.
          </p>
        </div>
      </section>
    </main>
  );
}
